module.exports = __webpack_public_path__ + "media/images/v2/streaming_blue-20af33c827dc235e9058a225a4730041.png";